import React from 'react';
import styled from 'styled-components';
import { Title, Button, Spin, theme } from 'components';
import NeedContext from '../NeedContext';
import UploadFileModal from './UploadFileModal';

const UploadFile: React.FC = () => {
  const { need, thumbnailLoading } = React.useContext(NeedContext);
  const [uploadOpen, setUploadOpen] = React.useState(false);

  return (
    <>
      <StyledWrapper>
        <Title level={3}>
          {need.thumbnail ? 'Current thumbnail:' : 'No thumbnail selected'}
        </Title>
        <StyledImageWrapper>
          {thumbnailLoading && (
            <Spin center size="large" showBackdrop position="absolute" />
          )}
          {need.thumbnail && <img src={need.thumbnail} />}
        </StyledImageWrapper>
        <StyledButtonWrapper>
          <Button type="primary" onClick={() => setUploadOpen(true)}>
            Upload Files
          </Button>
        </StyledButtonWrapper>
      </StyledWrapper>
      <UploadFileModal visible={uploadOpen} setVisible={setUploadOpen} />
    </>
  );
};

const StyledWrapper = styled.div`
  max-width: 800px;
  width: 100%;
`;

const StyledImageWrapper = styled.div`
  margin-bottom: 25px;
  position: relative;
  min-height: 200px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    box-shadow: ${theme.getElevation()};
  }
`;

const StyledButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export default UploadFile;
